// Kimlik ve vergi: vergi dairesi, ticaret sicil ve yetkili kişi (tüzel kişide).
import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { AccountCardForm } from '../useAccountCardForm';
import { L, SectionTitle } from './fields';

export const TaxInfoSection: React.FC<{ f: AccountCardForm }> = ({ f }) => {
  const { t } = useTranslation('accounting');
  const d = f.accountData;
  return (
    <>
      <SectionTitle title={t(`${L}.layout.sections.taxinfo`, 'Kimlik ve vergi')} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth size="small" label={t(`${L}.fields.taxOffice`)}
            value={d.taxOffice} onChange={(e) => f.handleChange('taxOffice', e.target.value)}
          />
        </Grid>
        {!f.isRealPerson && (
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth size="small" label={t(`${L}.fields.tradeRegisterNumber`)}
              value={d.tradeRegisterNumber} onChange={(e) => f.handleChange('tradeRegisterNumber', e.target.value)}
            />
          </Grid>
        )}
        {f.isLegalPerson && (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth size="small" label={t(`${L}.fields.authorizedPerson`)}
                value={d.authorizedPerson} onChange={(e) => f.handleChange('authorizedPerson', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth size="small" type="tel" label={t(`${L}.fields.authorizedPersonPhone`)}
                placeholder={t(`${L}.placeholders.phone`)}
                value={d.authorizedPersonPhone} onChange={(e) => f.handleChange('authorizedPersonPhone', e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
        {t(`${L}.layout.taxinfoHint`, 'Unvan, vergi no ve grup üstte sabit. VKN yazılınca tür seçilir; "Sorgula" unvanı ve e-Fatura durumunu getirir.')}
      </Typography>
    </>
  );
};
